export default __webpack_public_path__ + "static/media/masterplan-labels-2400px.7460f200.jpg";